/* eslint-disable import/prefer-default-export */
const LOCAL_HOST = 'localhost';

export const STAGING_HOST = 'website.staging.storedge.com';

export const PRODUCTION_HOST = 'website.storedge.com';

export const getWebDomain = (currentHost, site, slug = null) => {
  if (currentHost.startsWith(LOCAL_HOST)) {
    const { VOYAGER_WEB_HOST, VOYAGER_WEB_PORT, VOYAGER_WEB_PROTOCOL } = process.env;
    return `${VOYAGER_WEB_PROTOCOL}://${VOYAGER_WEB_HOST}:${VOYAGER_WEB_PORT}/${slug}`;
  }

  const { identifier, primaryHostname } = site;

  if (currentHost.endsWith(STAGING_HOST)) {
    return `https://${identifier}.${STAGING_HOST}/${slug}`;
  }

  if (!primaryHostname) {
    return `https://${identifier}.${PRODUCTION_HOST}/${slug}`;
  }

  const { hostname, ssl } = primaryHostname;
  const protocol = ssl ? 'https' : 'http';
  return `${protocol}://${hostname}/${slug}`;
};

export const validateDomain = (value) => {
  // allowing blank domains to be used as a placeholder
  if (!value) {
    return true;
  }

  // Regex taken (and slightly modified) from this answer: https://stackoverflow.com/a/10306731
  return /^[a-zA-Z0-9]([a-zA-Z0-9-.]{1,61})?[a-zA-Z0-9](?!\.)?\.[a-zA-Z]{2,}$/.test(value);
};

export const validateWww = (value) => {
  // allowing blank domains to be used as a placeholder
  if (!value) {
    return true;
  }

  return !value.toLowerCase().startsWith('www.');
};
